var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { AlertAFY, icons, severity, typeAlert, variantsAlert, } from "@affinitysystemsgroup/github-packages-affinity-components/dist";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import * as catalogConst from "../../const/catalog";
import { STEP_CLIENTRECORD } from "../../const/catalog";
import { stepProgress } from "../../dataBase/stepProgress";
import LocalStorageService from "../../services/localStorage";
import showToast from "../../services/toast";
import { quoteAll, quoteAllClearData } from "../../store/generateQuote/actions";
import { identificationType } from "../../store/identificationType/actions";
import { personById, personByIdClearData } from "../../store/person/actions";
import { policyCancelClearData } from "../../store/policy/actions";
import { cancelQuoteClearData } from "../../store/cancelQuote/actions";
import { formattedDate } from "../../utils/date";
import { GetCatalogsType } from "../../fnx/catalog/getCatalogsType";
import { getCatalogsTypeClearData } from "../../store/catalog/actions";
import { showErrorToast } from "../../fnx/showError";
import { showToastSuccessMessage } from "../../fnx/sendSuccessMessage";
import { useTranslation } from "react-i18next";
import { beneficiaryColumns, Columns, insuredColumns, } from "./resources/clientRecordDTO";
import "./assets/style.css";
import { ClientRecordView } from "./ui/view";
import useSelectors from "./components/selectors";
import useUI from "./components/ui";
import useClientRecord from "./components/clientRecord";
import { ClientRecordHeader } from "./ui/header";
import { Modal, ModalConfirm, ModalReason } from "./resources/modals";
import PagesHeader from "ah_utility/PagesHeader";
import { useGetSteps } from "../../utils/getSteps";
import { useGetSummary } from "../../utils/getSummary";
import { buildAndSaveWorkflowSteps, useGetInformationSteps, } from "ah_utility/workflow";
import { useCompleteStep } from "../../utils/responseComplete";
import { getUserNameFromStorage } from "ah_utility/AuthValidation";
import { searchPermissionInRoles } from "../../utils/authUtils";
import { postLoginAPI } from "../../resources/helper/login";
import { GetProjectOne } from "../../fnx/project/projectOne";
import { useGetWokFlow } from "../../fnx/workFlow/getWorkFlow";
import { projectOneClearData } from "../../store/project/actions";
import { getWorkFlowClearData } from "../../store/workFlow/actions";
import { getFlagValue } from "ah_utility/fnxUtils";
import { getQuoteList } from "../../utils/normalizeQuoteResponse";
import { usePersonAccountValidation } from "./hooks";
import { formatToTwoDecimals } from "../../utils/getPrice";
var storageKey2 = "assurehub";
var lsLogin = new LocalStorageService(storageKey2);
export var ClientRecordPage = function () {
    var STEP = STEP_CLIENTRECORD;
    var dispatch = useDispatch();
    var navigate = useNavigate();
    var id = useParams().id;
    var _a = React.useState(true), enable = _a[0], setEnable = _a[1];
    var _b = React.useState(1), page = _b[0], setPage = _b[1];
    var company = React.useState(lsLogin.getUserLoginStored().subdomain || "")[0];
    var _c = useState(getUserNameFromStorage() || ""), userName = _c[0], setUserName = _c[1];
    var _d = useState(""), userNameError = _d[0], setUserNameError = _d[1];
    var _e = useState(""), password = _e[0], setPassword = _e[1];
    var _f = useState(false), isValidating = _f[0], setIsValidating = _f[1];
    var _g = useState(""), passwordError = _g[0], setPasswordError = _g[1];
    var _h = useState(""), currentPersonId = _h[0], setCurrentPersonId = _h[1];
    var _j = React.useState(false), triggerPermissionList = _j[0], setTriggerPermissionList = _j[1];
    var _k = React.useState(5000), limit = _k[0], setLimit = _k[1];
    var _l = useState(false), showInfo = _l[0], setShowInfo = _l[1];
    var _m = useState([]), clientInfo = _m[0], setClientInfo = _m[1];
    var _o = useState([]), rowsQuote = _o[0], setRowsQuote = _o[1];
    var _p = useState(false), showBeneficiariesModal = _p[0], setShowBeneficiariesModal = _p[1];
    var _q = useState(false), openModalReason = _q[0], setOpenModalReason = _q[1];
    // const [steps, setSteps] = React.useState<MenuItem[]>([]);
    var _r = useState(false), showInsuredModal = _r[0], setShowInsuredModal = _r[1];
    var _s = useState([]), beneficiariesRows = _s[0], setBeneficiariesRows = _s[1];
    var _t = useState([]), insuredRows = _t[0], setInsuredRows = _t[1];
    var _u = useState(""), documentNumber = _u[0], setDocumentNumber = _u[1];
    var _v = useState(""), documentType = _v[0], setDocumentType = _v[1];
    var _w = useState([]), filtersII = _w[0], setFiltersII = _w[1];
    var _x = React.useState([]), breadCrumbs = _x[0], setBreadCrumbs = _x[1];
    var _y = useState(true), showNextDisabled = _y[0], setShowNextDisabled = _y[1];
    var storageKeyVariables = "afy-variables";
    var lsVariables = new LocalStorageService(storageKeyVariables);
    var _z = useState(""), documentName = _z[0], setDocumentName = _z[1];
    var _0 = useCompleteStep(), runComplete = _0.runComplete, loadingComplete = _0.loadingComplete, responseComplete = _0.responseComplete, errorComplete = _0.errorComplete;
    var _1 = useState(false), openModalConfirm = _1[0], setOpenModalConfirm = _1[1];
    var _2 = useState([]), reasonCancellation = _2[0], setReasonCancellation = _2[1];
    var _3 = useState(""), policyId = _3[0], setPolicyId = _3[1];
    var _4 = useState(true), type = _4[0], setType = _4[1]; //cotizacion = false o poliza = true
    var _5 = useState(""), codigo = _5[0], setCodigo = _5[1];
    var _6 = useState(""), status = _6[0], setStatus = _6[1];
    var _7 = useState(false), openAlert = _7[0], setOpenAlert = _7[1];
    var _8 = useState(""), alertMessage = _8[0], setAlertMessage = _8[1];
    var _9 = useState(false), genderMissing = _9[0], setGenderMissing = _9[1];
    var _10 = useState("Póliza"), modalTitle = _10[0], setModalTitle = _10[1];
    var _11 = useState(false), triggerCatalogs = _11[0], setTriggerCatalogs = _11[1];
    var t = useTranslation().t;
    var _12 = useState(null), dataAddress = _12[0], setDataAddress = _12[1];
    var _13 = useState([]), listIdentificationType = _13[0], setListIdentificationType = _13[1];
    var _14 = React.useState({
        show: false,
        message: "",
        type: typeAlert.success,
    }), seeToast = _14[0], setSeeToast = _14[1];
    var pathname = useLocation().pathname;
    var pathLocation = "/" + pathname.split("/")[1];
    var _15 = React.useState({}), sessionData = _15[0], setSessionData = _15[1];
    var _16 = React.useState(false), triggerWorkflow = _16[0], setTriggerWorkflow = _16[1];
    var _17 = React.useState(""), workflowId = _17[0], setWorkflowId = _17[1];
    var summary = useGetSummary();
    var cardsOnlyLimit = getFlagValue("afy-cards-only-higher-limit");
    var onlyCreditCard = getFlagValue("afy-validate-only-credit-card");
    var validatePersonAccounts = usePersonAccountValidation({
        cardsOnlyLimit: cardsOnlyLimit,
        onlyCreditCard: onlyCreditCard,
        setOpenAlert: setOpenAlert,
        setAlertMessage: setAlertMessage,
    }).validatePersonAccounts;
    var _18 = useSelectors(), responsePerson = _18.responsePerson, errorPerson = _18.errorPerson, responseAllQuote = _18.responseAllQuote, responseIdentificationType = _18.responseIdentificationType, responseBeneficiary = _18.responseBeneficiary, responseInsured = _18.responseInsured, loadingPerson = _18.loadingPerson, loadingIdentificationType = _18.loadingIdentificationType, loadingBeneficiary = _18.loadingBeneficiary, responseCancelPolicy = _18.responseCancelPolicy, errorCancelPolicy = _18.errorCancelPolicy, loadingCancelPolicy = _18.loadingCancelPolicy, responseCancelQuote = _18.responseCancelQuote, errorCancelQuote = _18.errorCancelQuote, loadingCancelQuote = _18.loadingCancelQuote, loadingAllQuote = _18.loadingAllQuote;
    var _19 = useClientRecord(setShowNextDisabled, setDocumentType, setDocumentName, setDocumentNumber, documentNumber, setSeeToast, typeAlert, listIdentificationType, lsVariables, documentType, setOpenAlert), handleChange = _19.handleChange, handleChangeSelect = _19.handleChangeSelect, handleSearch = _19.handleSearch, isValid = _19.isValid, validDocument = _19.validDocument;
    var _20 = useGetInformationSteps(pathLocation), instanceId = _20.instanceId, workFlowId = _20.workFlowId, currentStep = _20.currentStep, nextStep = _20.nextStep;
    var _21 = useUI(setShowBeneficiariesModal, setShowInsuredModal, id, STEP, isValid, setSeeToast, setOpenModalConfirm, setPolicyId, setType, setCodigo, setStatus, setModalTitle, setTriggerCatalogs, instanceId || "", workFlowId || "", currentStep || "", nextStep || "", runComplete, sessionData, dataAddress, documentNumber, documentType), handleClickContextMenu = _21.handleClickContextMenu, handleClickNext = _21.handleClickNext, handleClickPrevious = _21.handleClickPrevious, handleCancelPolicy = _21.handleCancelPolicy, isNextDisabled = _21.isNextDisabled, projectId = _21.projectId, triggerProject = _21.triggerProject, dataRow = _21.dataRow, isLastPage = _21.isLastPage;
    var _22 = GetCatalogsType(triggerCatalogs, enable, page, limit, catalogConst.CATALOG_REASON_CANCELLATION), responseGetCatalogsType = _22.responseGetCatalogsType, loadingGetCatalogsType = _22.loadingGetCatalogsType, errorGetCatalogsType = _22.errorGetCatalogsType;
    var _23 = GetProjectOne(triggerProject, projectId), responseOneProject = _23.responseOneProject, errorOneProject = _23.errorOneProject, loadingOneProject = _23.loadingOneProject;
    var _24 = useGetWokFlow(triggerWorkflow, workflowId, function () { return setTriggerWorkflow(false); }), loadingWorkFlow = _24.loadingWorkFlow, responseWorkFlow = _24.responseWorkFlow, errorWorkflow = _24.errorWorkflow;
    useEffect(function () {
        var _a, _b, _c, _d;
        dispatch(personByIdClearData());
        dispatch(quoteAllClearData());
        dispatch(identificationType({ enable: enable, page: page, limit: limit }));
        setBreadCrumbs(stepProgress(STEP, true));
        // setSteps(stepProgress(STEP));
        // Comes from the client page
        if (id) {
            setDocumentNumber(id);
            dispatch(
            //personById({ enable: enable, page: page, limit: limit, numberId: id }),
            personById(id));
            return;
        }
        // Si se regresó con "Anterior" desde un paso posterior, restauramos
        // la búsqueda con el documento guardado en steps[i].details.personData.
        try {
            var stepsRaw = localStorage.getItem("steps");
            if (!stepsRaw)
                return;
            var stepsArr = JSON.parse(stepsRaw);
            var currentEntry = stepsArr.find(function (s) { return s.pathUrl === pathname; });
            var storedDoc = (_b = (_a = currentEntry === null || currentEntry === void 0 ? void 0 : currentEntry.details) === null || _a === void 0 ? void 0 : _a.personData) === null || _b === void 0 ? void 0 : _b.documentNumber;
            var storedType = (_d = (_c = currentEntry === null || currentEntry === void 0 ? void 0 : currentEntry.details) === null || _c === void 0 ? void 0 : _c.personData) === null || _d === void 0 ? void 0 : _d.identificationTypeId;
            if (storedDoc) {
                setDocumentNumber(storedDoc);
                if (storedType)
                    setDocumentType(storedType);
                var cleanedDoc = storedDoc.replace(/-/g, "").replace(/_/g, "");
                dispatch(personById({
                    document: cleanedDoc,
                    identificationTypeId: storedType,
                }));
            }
        }
        catch (e) {
            console.warn("clientRecord: no se pudo restaurar el documento desde steps", e);
        }
    }, []);
    useEffect(function () {
        var _a;
        if (responseOneProject) {
            var alterWorkflow = (_a = responseOneProject === null || responseOneProject === void 0 ? void 0 : responseOneProject.workflows) === null || _a === void 0 ? void 0 : _a.find(function (workflow) { return workflow.page === "alter_flow"; });
            if (!alterWorkflow) {
                showToastSuccessMessage("El producto no tiene un flujo de venta alterno asociado", typeAlert.warning, setSeeToast);
            }
            else {
                setWorkflowId(alterWorkflow.id);
                localStorage.setItem("WorkFlowId", alterWorkflow.id);
                setTriggerWorkflow(true);
            }
            dispatch(projectOneClearData());
        }
    }, [responseOneProject]);
    useEffect(function () {
        var _a, _b, _c, _d, _e, _f;
        if (responseWorkFlow && (dataRow === null || dataRow === void 0 ? void 0 : dataRow.id)) {
            var nodes = (_b = (_a = responseWorkFlow.draftDataMap) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.nodes;
            var edges = (_d = (_c = responseWorkFlow.draftDataMap) === null || _c === void 0 ? void 0 : _c.data) === null || _d === void 0 ? void 0 : _d.edges;
            buildAndSaveWorkflowSteps(nodes, edges, "steps", true);
            dispatch(getWorkFlowClearData());
            navigate("/confirmationForm/".concat((_e = dataRow === null || dataRow === void 0 ? void 0 : dataRow.id) !== null && _e !== void 0 ? _e : "", "/true/false/").concat((_f = dataRow === null || dataRow === void 0 ? void 0 : dataRow.productId) !== null && _f !== void 0 ? _f : ""));
        }
    }, [responseWorkFlow]);
    // Handle cancel policy error
    useEffect(function () {
        if (errorCancelPolicy) {
            showErrorToast(errorCancelPolicy, setSeeToast, t);
            dispatch(policyCancelClearData());
        }
    }, [errorCancelPolicy, dispatch]);
    useEffect(function () {
        var _a, _b;
        if (errorPerson) {
            if (((_b = (_a = errorPerson.errors) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.code) === 404) {
                setShowInfo(false);
                setShowNextDisabled(validDocument(documentName, documentNumber) ? false : true);
                setSeeToast({
                    show: true,
                    message: "¡No se encontraron datos para la búsqueda!",
                    type: typeAlert.info,
                });
            }
        }
    }, [errorPerson]);
    useEffect(function () {
        if (errorComplete) {
            setSeeToast({
                show: true,
                message: errorComplete.message,
                type: typeAlert.error,
            });
        }
    }, [errorComplete]);
    useEffect(function () {
        var _a, _b;
        if (responsePerson) {
            setShowInfo(true);
            setCurrentPersonId(responsePerson.clientId);
            var addressData = {
                providence: responsePerson.catalogRegionLevel1,
                town: responsePerson.catalogRegionLevel2,
                sector: responsePerson.catalogRegionLevel3,
                address: responsePerson.addressA,
            };
            setDataAddress(addressData);
            // Actualizar sessionData con toda la estructura de datos
            setSessionData({
                additionalContentMap: (responsePerson === null || responsePerson === void 0 ? void 0 : responsePerson.additionalContentMap) || {},
                clientId: responsePerson.clientId,
                numberId: responsePerson.numberId,
                personData: responsePerson,
            });
            validatePersonAccounts((_a = responsePerson === null || responsePerson === void 0 ? void 0 : responsePerson.additionalContentMap) === null || _a === void 0 ? void 0 : _a.accounts);
            var hasAccounts = !!((_b = responsePerson === null || responsePerson === void 0 ? void 0 : responsePerson.additionalContentMap) === null || _b === void 0 ? void 0 : _b.accounts);
            var validations = [
                {
                    condition: !hasAccounts,
                    toast: {
                        show: true,
                        message: "¡La persona no es cliente del banco!",
                        type: typeAlert.warning,
                    },
                    onFail: function () { },
                },
            ];
            var failing = validations.find(function (_a) {
                var condition = _a.condition;
                return condition;
            });
            if (failing) {
                setSeeToast(failing.toast);
                failing.onFail();
            }
            else {
                setGenderMissing(false);
            }
            dispatch(quoteAll({
                clientId: responsePerson.clientId,
                enable: enable,
                page: page,
                limit: limit,
                numberId: responsePerson.numberId,
                fields: "abc",
                isLegacy: false,
            }));
            setClientInfo([
                {
                    label: "Nombre completo",
                    value: "".concat(responsePerson.lastNameA, " ").concat(responsePerson.lastNameB, ", ").concat(responsePerson.firstNameA, " ").concat(responsePerson.firstNameB),
                },
                {
                    label: "Fecha de nacimiento",
                    value: formattedDate(responsePerson.dob),
                },
                {
                    label: "Identificación",
                    value: documentNumber ? documentNumber : responsePerson.numberId,
                },
                { label: "Teléfono casa", value: responsePerson.phone1 },
                { label: "Email", value: responsePerson.email },
                { label: "Dirección", value: responsePerson.addressA },
            ]);
        }
        if (id) {
            setShowNextDisabled(true);
        }
        else {
            setShowNextDisabled(!validDocument(documentName, documentNumber));
        }
        dispatch(personByIdClearData());
    }, [responsePerson]);
    // Handle cancel policy response
    useEffect(function () {
        if (responseCancelPolicy &&
            typeof responseCancelPolicy === "object" &&
            responseCancelPolicy !== true) {
            showToastSuccessMessage("Póliza cancelada exitosamente", typeAlert.success, setSeeToast);
            // Refresh the quotes list with current values
            var currentClientId = currentPersonId;
            var _term = documentNumber;
            _term = _term.replace(/-/g, "");
            _term = _term.replace(/_/g, "");
            if (_term && currentClientId) {
                dispatch(quoteAll({
                    clientId: currentClientId,
                    enable: enable,
                    page: page,
                    limit: limit,
                    numberId: _term,
                    fields: "abc",
                    isLegacy: false,
                }));
            }
            dispatch(policyCancelClearData());
        }
    }, [responseCancelPolicy, dispatch]);
    // Handle cancel quote response
    useEffect(function () {
        if (responseCancelQuote &&
            typeof responseCancelQuote === "object" &&
            responseCancelQuote !== true) {
            showToastSuccessMessage("Cotización cancelada exitosamente", typeAlert.success, setSeeToast);
            // Refresh the quotes list with current values
            var currentDocumentNumber = documentNumber;
            var currentClientId = currentPersonId;
            var _term = documentNumber;
            _term = _term.replace(/-/g, "");
            _term = _term.replace(/_/g, "");
            if (currentDocumentNumber && currentClientId) {
                setOpenModalConfirm(false);
                dispatch(quoteAll({
                    clientId: currentClientId,
                    enable: enable,
                    page: page,
                    limit: limit,
                    numberId: _term,
                    fields: "abc",
                    isLegacy: false,
                }));
            }
            dispatch(cancelQuoteClearData());
        }
    }, [responseCancelQuote, dispatch]);
    // Handle cancel quote error
    useEffect(function () {
        if (errorCancelQuote) {
            showErrorToast(errorCancelQuote, setSeeToast, t);
            dispatch(cancelQuoteClearData());
        }
    }, [errorCancelQuote, dispatch]);
    useEffect(function () {
        setRowsQuote([]);
        var quoteList = getQuoteList(responseAllQuote);
        if (quoteList.length > 0) {
            var srq = [];
            quoteList.map(function (item) {
                var _a, _b, _c, _d, _e, _f, _g, _h, _j;
                var prima = (_a = item.lastPrice) === null || _a === void 0 ? void 0 : _a.amount;
                srq.push({
                    id: item.id,
                    estado: (_b = item.catalogStatusQuote) === null || _b === void 0 ? void 0 : _b.description,
                    cotizacion: item.code,
                    poliza: (_c = item.policyId) === null || _c === void 0 ? void 0 : _c.code,
                    producto: (_d = item.productId) === null || _d === void 0 ? void 0 : _d.description,
                    plan: (_e = item.planId) === null || _e === void 0 ? void 0 : _e.name,
                    policyId: (_f = item.policyId) === null || _f === void 0 ? void 0 : _f.id,
                    prima: "".concat((_h = (_g = item.lastPrice) === null || _g === void 0 ? void 0 : _g.currencySymbol) !== null && _h !== void 0 ? _h : "", " ").concat(formatToTwoDecimals(prima !== null && prima !== void 0 ? prima : 0)),
                    productId: (_j = item.productId) === null || _j === void 0 ? void 0 : _j.id,
                    date: item.policyId ? item.policyId.effectiveFrom : item.creationDate,
                });
            });
            setRowsQuote(srq);
        }
        dispatch(quoteAllClearData());
    }, [responseAllQuote]);
    useEffect(function () {
        if (showBeneficiariesModal && showInsuredModal) {
            setShowBeneficiariesModal(false);
            setShowInsuredModal(false);
        }
    }, [showBeneficiariesModal, showInsuredModal]);
    useEffect(function () {
        var _a;
        setInsuredRows([]);
        if (responseInsured && ((_a = responseInsured.data) === null || _a === void 0 ? void 0 : _a.length) > 0) {
            responseInsured.data.map(function (item) {
                setInsuredRows(function (prev) {
                    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
                    return __spreadArray(__spreadArray([], prev, true), [
                        {
                            id: item.id,
                            type: (_a = item.catalogInsuredTypeInfo) === null || _a === void 0 ? void 0 : _a.description,
                            name: (_b = item.personInfo) === null || _b === void 0 ? void 0 : _b.firstNameA,
                            secondName: (_c = item.personInfo) === null || _c === void 0 ? void 0 : _c.firstNameB,
                            lastName: (_d = item.personInfo) === null || _d === void 0 ? void 0 : _d.lastNameA,
                            secondLastName: (_e = item.personInfo) === null || _e === void 0 ? void 0 : _e.lastNameB,
                            marriedName: (_f = item.personInfo) === null || _f === void 0 ? void 0 : _f.marriedName,
                            phone: (_g = item.personInfo) === null || _g === void 0 ? void 0 : _g.phone1,
                            email: (_h = item.personInfo) === null || _h === void 0 ? void 0 : _h.email,
                            dob: (_j = item.personInfo) === null || _j === void 0 ? void 0 : _j.dob,
                        },
                    ], false);
                });
            });
        }
    }, [responseInsured]);
    useEffect(function () {
        var _a;
        setBeneficiariesRows([]);
        if (responseBeneficiary && ((_a = responseBeneficiary === null || responseBeneficiary === void 0 ? void 0 : responseBeneficiary.data) === null || _a === void 0 ? void 0 : _a.length) > 0) {
            responseBeneficiary.data.map(function (item) {
                setBeneficiariesRows(function (prev) {
                    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
                    return __spreadArray(__spreadArray([], prev, true), [
                        {
                            id: item.id,
                            type: (_a = item.catalogBeneficiaryTypeInfo) === null || _a === void 0 ? void 0 : _a.description,
                            name: (_b = item.personInfo) === null || _b === void 0 ? void 0 : _b.firstNameA,
                            secondName: (_c = item.personInfo) === null || _c === void 0 ? void 0 : _c.firstNameB,
                            lastName: (_d = item.personInfo) === null || _d === void 0 ? void 0 : _d.lastNameA,
                            secondLastName: (_e = item.personInfo) === null || _e === void 0 ? void 0 : _e.lastNameB,
                            marriedName: (_f = item.personInfo) === null || _f === void 0 ? void 0 : _f.marriedName,
                            percentage: item.percentage,
                            phone: (_g = item.personInfo) === null || _g === void 0 ? void 0 : _g.phone1,
                            email: (_h = item.personInfo) === null || _h === void 0 ? void 0 : _h.email,
                            dob: (_j = item.personInfo) === null || _j === void 0 ? void 0 : _j.dob,
                        },
                    ], false);
                });
            });
        }
    }, [responseBeneficiary === null || responseBeneficiary === void 0 ? void 0 : responseBeneficiary.data]);
    useEffect(function () {
        var _a;
        if (responseIdentificationType === null || responseIdentificationType === void 0 ? void 0 : responseIdentificationType.data) {
            var data_1 = (_a = responseIdentificationType.data) === null || _a === void 0 ? void 0 : _a.map(function (identification) {
                return {
                    id: identification.id,
                    value: identification.id,
                    name: identification.description,
                };
            });
            setListIdentificationType(data_1);
            setDocumentType(function (prev) { var _a; return prev || ((_a = data_1[0]) === null || _a === void 0 ? void 0 : _a.id) || ""; });
            setDocumentName(function (prev) { var _a; return prev || ((_a = data_1[0]) === null || _a === void 0 ? void 0 : _a.name) || ""; });
        }
    }, [responseIdentificationType]);
    useEffect(function () {
        var _a;
        var newMap = (_a = summary === null || summary === void 0 ? void 0 : summary.data) === null || _a === void 0 ? void 0 : _a.map(function (e) { return ({
            name: e.label,
            label: e.value,
            type: "label",
        }); });
        setFiltersII(newMap);
    }, [summary]);
    // Handle catalogs response
    useEffect(function () {
        if (responseGetCatalogsType && Array.isArray(responseGetCatalogsType)) {
            var newArray = responseGetCatalogsType.map(function (item) { return ({
                id: item.id,
                value: item.id,
                name: item.description,
                type: item.code,
            }); });
            setReasonCancellation(newArray);
            setSelectedReasonCancellation(newArray.length > 0 ? newArray[0].value : "");
            dispatch(getCatalogsTypeClearData());
            setTriggerCatalogs(false);
        }
    }, [responseGetCatalogsType, dispatch]);
    var _25 = useState(""), selectedReasonCancellation = _25[0], setSelectedReasonCancellation = _25[1];
    var handleCloseModalConfirm = function () {
        setOpenModalConfirm(false);
    };
    var handleSubmitCancelPolicy = function () {
        if (selectedReasonCancellation) {
            handleCancelPolicy(selectedReasonCancellation, type, policyId);
            // Close modal immediately after submitting
            setOpenModalConfirm(false);
            setOpenModalReason(false);
            setTriggerCatalogs(false);
            setSelectedReasonCancellation("");
        }
    };
    var handleClickSeeDetails = function (data) { };
    var steps = useGetSteps();
    var handleChangeReason = function (value) {
        //setReasonCancellation(value);
        setSelectedReasonCancellation(value);
    };
    var handleUserNameChange = function (value) {
        setUserName(value);
        setUserNameError("");
    };
    var handlePasswordChange = function (value) {
        setPassword(value);
        setPasswordError("");
    };
    var validateAndSubmit = function () { return __awaiter(void 0, void 0, void 0, function () {
        var loginResponse, err_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setUserNameError("");
                    setPasswordError("");
                    if (!userName.trim()) {
                        setUserNameError("Debe ingresar el usuario");
                        return [2 /*return*/];
                    }
                    if (!password) {
                        setPasswordError("Debe ingresar la contraseña");
                        return [2 /*return*/];
                    }
                    setIsValidating(true);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, 4, 5]);
                    return [4 /*yield*/, postLoginAPI({ userName: userName, password: password })];
                case 2:
                    loginResponse = _a.sent();
                    if (!searchPermissionInRoles(loginResponse, "sale-policies-sumary-cancel")) {
                        setPasswordError("El usuario no cuenta con el permiso para cancelar");
                        setIsValidating(false);
                        return [2 /*return*/];
                    }
                    handleSubmitCancelPolicy();
                    setPassword("");
                    return [3 /*break*/, 5];
                case 3:
                    err_1 = _a.sent();
                    setPasswordError("Contraseña incorrecta");
                    return [3 /*break*/, 5];
                case 4:
                    setIsValidating(false);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    return (_jsxs(React.Fragment, { children: [_jsx(PagesHeader, { titlePage: "Registro de cliente", hideStep: false, steps: steps, completed: isLastPage }), _jsx(ClientRecordHeader, { loading: loadingPerson ||
                    loadingIdentificationType ||
                    loadingAllQuote ||
                    loadingCancelPolicy ||
                    loadingCancelQuote ||
                    loadingComplete ||
                    loadingOneProject ||
                    loadingWorkFlow, seeToast: seeToast, showToast: showToast, setSeeToast: setSeeToast, id: id, handleClickPrevious: handleClickPrevious }), _jsx(Modal, { title: "Beneficiarios", openModal: showBeneficiariesModal, columns: beneficiaryColumns, rows: beneficiariesRows, close: function () { return setShowBeneficiariesModal(false); } }), _jsx(Modal, { title: "Asegurados", openModal: showInsuredModal, columns: insuredColumns, rows: insuredRows, close: function () { return setShowInsuredModal(false); } }), _jsx(ModalConfirm, { openModal: openModalConfirm, modalTitle: modalTitle, codigo: codigo, status: status, type: type, policyId: policyId, selectedReasonCancellation: selectedReasonCancellation, onClose: handleCloseModalConfirm, onOpenModalReason: function () { return setOpenModalReason(true); }, onCancelPolicy: handleCancelPolicy }), _jsx(ModalReason, { openModal: openModalReason, reasonCancellation: reasonCancellation, userName: userName, userNameError: userNameError, password: password, passwordError: passwordError, isValidating: isValidating, onClose: function () { return setOpenModalReason(false); }, onChangeReason: handleChangeReason, onUserNameChange: handleUserNameChange, onPasswordChange: handlePasswordChange, onValidateAndSubmit: validateAndSubmit, onBack: function () {
                    setPassword("");
                    setPasswordError("");
                    setUserNameError("");
                    setOpenModalReason(false);
                } }), _jsx("div", __assign({ style: { marginBottom: openAlert ? "15px" : "0" } }, { children: _jsx(AlertAFY, { autoClose: 10000, description: alertMessage, iconClose: icons.Close, iconCloseColor: "#fff", isOpen: openAlert, onClose: function () { return setOpenAlert(false); }, title: "", variant: variantsAlert.filled, severity: severity.warning, width: "100%", spacing: 0, backgroundColor: "", textColor: "", iconColor: "" }) })), (listIdentificationType === null || listIdentificationType === void 0 ? void 0 : listIdentificationType.length) > 0 && (_jsx(ClientRecordView, { title: "Registro de cliente", hideFilter: !!id, breadcrumbs: breadCrumbs, stepProgress: steps, previousLabel: "Anterior", nextLabel: "Nueva cotización", nextDisabled: !isNextDisabled || genderMissing, showInfo: showInfo, showBeneficiariesModal: false, showInsuredModal: false, clientInfo: clientInfo, documentTypeList: listIdentificationType, rows: rowsQuote, filters: filtersII, columns: Columns(handleClickContextMenu), handleChange: handleChange, onClickSeeDetails: handleClickSeeDetails, onSearch: handleSearch, handleChangeSelect: handleChangeSelect, onClickNext: handleClickNext, onClickPrevious: handleClickPrevious, openAlert: openAlert }))] }));
};
